$(document).ready(function () 
{
    $('.buying_guide_filter .filter_list a').click(function (e) { 
        e.preventDefault();
        var active_filter = $(this).data('filter_by');
        console.log("active_filter: ",active_filter);
        $('.buying_guide_filter .filter_list a').removeClass('active');
        $(this).addClass('active');
        if (active_filter == "show_all") 
        {
            $('.bridgman_guides_blocks .blog-grid-item').removeClass('hide');
        }
        else
        {
            $('.bridgman_guides_blocks .blog-grid-item').addClass('hide');
            $('.bridgman_guides_blocks .'+active_filter).removeClass('hide');
        }
        return false;
    });    
});